var map = {
	"./FooterContainerWidget/FooterContainerWidgetClass.ts": 15416,
	"./FooterContainerWidget/FooterContainerWidgetComponent.tsx": 88743,
	"./FooterContainerWidget/FooterContainerWidgetEditingConfig.ts": 74766,
	"./ImageFooterWidget/ImageFooterWidgetClass.ts": 82304,
	"./ImageFooterWidget/ImageFooterWidgetComponent.tsx": 59493,
	"./ImageFooterWidget/ImageFooterWidgetEditingConfig.ts": 17126,
	"./ImageWidget/ImageWidgetClass.ts": 1256,
	"./ImageWidget/ImageWidgetComponent.tsx": 481,
	"./ImageWidget/ImageWidgetEditingConfig.ts": 82965,
	"./InfoPopupWidget/InfoPopupWidgetClass.ts": 50400,
	"./InfoPopupWidget/InfoPopupWidgetComponent.tsx": 97019,
	"./InfoPopupWidget/InfoPopupWidgetEditingConfig.ts": 27750,
	"./LinkContainerWidget/LinkContainerWidgetClass.ts": 52492,
	"./LinkContainerWidget/LinkContainerWidgetComponent.tsx": 5645,
	"./LinkContainerWidget/LinkContainerWidgetEditingConfig.ts": 94822,
	"./LinkWidget/LinkWidgetClass.ts": 66514,
	"./LinkWidget/LinkWidgetComponent.tsx": 6575,
	"./LinkWidget/LinkWidgetEditingConfig.ts": 11179,
	"./LinksFooterWidget/LinksFooterWidgetClass.ts": 81688,
	"./LinksFooterWidget/LinksFooterWidgetComponent.tsx": 42610,
	"./LinksFooterWidget/LinksFooterWidgetEditingConfig.ts": 83758,
	"./RecentProjectsLinkWidget/RecentProjectsLinkWidgetClass.ts": 48360,
	"./RecentProjectsLinkWidget/RecentProjectsLinkWidgetComponent.tsx": 54116,
	"./RecentProjectsLinkWidget/RecentProjectsLinkWidgetEditingConfig.ts": 21982,
	"./RecentProjectsWidget/RecentProjectsWidgetClass.ts": 34208,
	"./RecentProjectsWidget/RecentProjectsWidgetComponent.tsx": 7179,
	"./RecentProjectsWidget/RecentProjectsWidgetEditingConfig.ts": 19334,
	"./RecentProjectsWidget/shared/ProjectInfo.tsx": 79968,
	"./RecentProjectsWidget/shared/ProjectInfoSkeleton.tsx": 6905,
	"./SectionWidget/SectionWidgetClass.ts": 5244,
	"./SectionWidget/SectionWidgetComponent.tsx": 31741,
	"./SectionWidget/SectionWidgetEditingConfig.ts": 24012,
	"./TextFooterWidget/TextFooterWidgetClass.ts": 54438,
	"./TextFooterWidget/TextFooterWidgetComponent.tsx": 71392,
	"./TextFooterWidget/TextFooterWidgetEditingConfig.ts": 28004,
	"./TextWidget/TextWidgetClass.ts": 8700,
	"./TextWidget/TextWidgetComponent.tsx": 35773,
	"./TextWidget/TextWidgetEditingConfig.ts": 30035,
	"./YoutubeVideoWidget/YoutubeVideoWidgetClass.ts": 40454,
	"./YoutubeVideoWidget/YoutubeVideoWidgetComponent.tsx": 14555,
	"./YoutubeVideoWidget/YoutubeVideoWidgetEditingConfig.ts": 91645,
	"./index.ts": 35025
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48621;